import { CategoryLanding } from '@app/code/src/containers/MergedStore/Category/CategoryLanding'
import { CategoryLandingProps } from '@app/code/src/containers/MergedStore/Category/CategoryLanding.types'
import { GetServerSideProps } from 'next/types'
import { PageContainer } from '../../components/layout'
import { Routes } from '@dtx-company/true-common/src/constants/routes'
import { UNAUTHORIZED_PRINT_STORE_FALLBACK_LINK } from '../../constants/store'
import { prismicClient } from '@app/prismic/src/utils'
import { useRedirectOnAuthChanges } from '@dtx-company/inter-app/src/hooks/auth/useRedirectOnAuthChanges'
import { useStoreAuthorizationState } from '../../hooks/useStoreAuthorizationState'

export const getServerSideProps: GetServerSideProps = async () => {
  const { data } = await prismicClient.getSingle('merged_store_category_l', {})

  return {
    props: {
      data
    }
  }
}

const LoggedOutPrintStoreLandingPage = ({ data }: { data: CategoryLandingProps }): JSX.Element => {
  const { isAuthorized } = useStoreAuthorizationState()

  useRedirectOnAuthChanges(false, false, UNAUTHORIZED_PRINT_STORE_FALLBACK_LINK)

  return (
    <PageContainer page={Routes.PRINT_STORE_LANDING_PAGE} disableSideNav>
      {isAuthorized && <CategoryLanding data={data} />}
    </PageContainer>
  )
}

export default LoggedOutPrintStoreLandingPage
